import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/cms-development/path_cms.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose cms_path p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2 style={{ color: "#fff" }}>
              Your Path to Superior Content Management
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p style={{ color: "#fff" }}>
              A custom Content Management System (CMS) elevates your digital
              presence, streamlines content operations, and enhances user
              engagement. Our expert CMS development services cater to both
              startups and enterprises to deliver a robust, scalable, and
              tailored solution.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Real-Time Content
                      <br /> Updates
                    </h5>
                    <p>
                      Instantly publish and modify content across platforms,
                      ensuring immediate visibility and engagement.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Sustainable Digital
                      <br /> Strategy
                    </h5>
                    <p>
                      Develop a future-proof CMS that evolves with your
                      business, supporting long-term growth and scalability.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Performance
                      <br />
                      Optimization
                    </h5>
                    <p>
                      Optimize load times and content delivery for a seamless
                      user experience and improved site performance.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Seamless
                      <br /> Integration
                    </h5>
                    <p>
                      Easily integrate with other software and services,
                      managing content across various channels from one
                      platform.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Advanced
                      <br />
                      Security
                    </h5>
                    <p>
                      Protect your content and user data with cutting-edge
                      security measures and regular updates.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      User Insights &
                      <br /> Analytics
                    </h5>
                    <p>
                      Gain actionable insights into user behavior and content
                      performance with in-depth analytics and custom reports.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={3}
                xxl={3}
                className="mb-4 mb-md-0"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">07</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Customizable
                      <br /> Templates
                    </h5>
                    <p>
                      Create and modify templates to match your brand’s
                      identity, with personalized user roles and permissions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">08</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Cost
                      <br />
                      Efficiency
                    </h5>
                    <p>
                      Reduce long-term costs with an in-house CMS, eliminating
                      dependency on third-party licenses and subscriptions.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
